import { Group, Groups, GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { hasAdminPrivileges } from '@front-app/util/permission';
import {
	computed,
	reactive,
	Ref,
	toRefs,
} from '@vue/composition-api';

export interface UseSelectAdminGroups {
	checkedGroupIds: Ref<string[]>;
	hasAdministerableGroups: Ref<boolean>;
	isGroupChecked(group: Group): boolean;
	addGroup(group: Group): void;
	removeGroup(group: Group): void;
	setGroups(groups: Groups): void;
	clearAll(): void;
	isCsr: Ref<boolean>;
}

export const useSelectAdminGroups = (groups: Ref<GroupWithCommunity[]>, isCsr: Ref<boolean>): UseSelectAdminGroups => {
	const state = reactive({
		checkedGroupIds: [] as string[],
	});
	const hasAdministerableGroups = computed(() => groups.value.some((g: Group) => hasAdminPrivileges(g.role, isCsr.value)));
	const isIdChecked = (id: string) => state.checkedGroupIds.includes(id);
	const isGroupChecked = ({ id }: Group) => isIdChecked(id);
	const addGroup = (group: Group) => {
		if (!hasAdminPrivileges(group.role, isCsr.value)) {
			return;
		}
		state.checkedGroupIds = state.checkedGroupIds.concat(group.id);
	};
	const setGroups = (groupsToAdd: Groups) => {
		state.checkedGroupIds = groupsToAdd
			.filter((g) => hasAdminPrivileges(g.role, isCsr.value))
			.map(({ id }) => id);
	};
	const removeGroup = (g: Group) => {
		state.checkedGroupIds = state.checkedGroupIds.filter((id) => id !== g.id);
	};
	const clearAll = (): void => {
		state.checkedGroupIds = [];
	};

	return {
		...toRefs(state),
		hasAdministerableGroups,
		isGroupChecked,
		addGroup,
		setGroups,
		removeGroup,
		clearAll,
		isCsr,
	};
};
